import SaleSummary from "../components/Flight/SaleSummary"
import DefaultTemplate from "./DefaultTemplate"
import { Card } from "react-bootstrap";
import Goair from "../libs/images/AirlineLogo/G8.png";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { add_member, get_fare_quote_resultindex, get_fare_rule_resultindex, get_members, showAlertMessage } from "../components/server/api";
import { useParams } from "react-router-dom";
import { setFareQuote, setFareRule, setPassengerIds } from "../redux/global/global.action";
import Loader from "../components/loader/Loader";
import moment from "moment";
import { flight_dateTimeFormat } from "./Home";
import { secondsToHms } from "../components/Return/ReturnFlightDetails";

export const PassengerData = (props) => {
  const dispatch = useDispatch();
  const user_id = useSelector(state => state.global.user_id);
  const passenger_ids = useSelector(state => state.global.passenger_ids)

  const passenger_data = useSelector(state => state.global.passenger_data);
  const [searchPass,setSearchPass] = useState([]);
  const [checkSave,setCheckSave] = useState(0)
  const [passengerList,setPassengerList] = useState([]);
  const [formData, updateFormData] = useState({
    user_id: user_id,
    title: '',
    firstname: '',
    lastname: '',
    paxtype: 1,
    dateofbirth: '',
    gender: 1,
    passportNo: '',
    passportExpiry: '',
    addressLine: '',
    city: '',
    countryCode: '91',
    cellCountryCode: '91',
    contactNo: '',
    nationality: '',
    email: '',
  });

  const select_member = (obj) => {
    // passenger_data.push(obj)


  }

  const get_passenger_list = async () => {
    get_members({
      user_id:user_id
    })
    .then(dt=>{
      if(dt.status && dt.data && dt.data.length){
      
        const result = dt.data.filter(ps => ps.paxtype==props.PassengerType);
        setPassengerList(result)
      }
    
    })
  }
  useEffect(() => {
    get_passenger_list()
  }, [])

  function remove_duplicates(arr) {
    var obj = {};
    var ret_arr = [];
    for (var i = 0; i < arr.length; i++) {
        obj[arr[i]] = true;
    }
    for (var key in obj) {
        ret_arr.push(key);
    }
    return ret_arr;
}

  const add_passenger_data = async (index, type = 'adult') => {

    const { title, firstname, dateofbirth, gender, passportNo, passportExpiry, addressLine, email, contactNo } = formData;

    if (firstname === '') {
      showAlertMessage('oops', 'Please add your name!', false, true)
    } else if (contactNo === '') {
      showAlertMessage('oops', 'Please add your contact no!', false, true)
    }
    else if (dateofbirth === '') {
      showAlertMessage('oops', 'Please add date of birth!', false, true)
    }
    else if (email === '') {
      showAlertMessage('oops', 'Please add your email!', false, true)
    } else {
      //     alert(JSON.stringify(formData))
      //  return;
      const response = await add_member({
        ...formData,
        not_ids:passenger_ids,
        dateofbirth: moment(moment(formData.dateofbirth)).format('YYYY-MM-DD'),
      });
      if (response && response.status) {
        // updateFormData({
        //   user_id: user_id,
        //   title: '',
        //   firstname: '',
        //   lastname: '',
        //   paxtype: 1,
        //   dateofbirth: '',
        //   gender: 1,
        //   passportNo: '',
        //   passportExpiry: '',
        //   addressLine: '',
        //   city: '',
        //   countryCode: '91',
        //   cellCountryCode: '91',
        //   contactNo: '',
        //   nationality: '',
        //   email: '',
        // })
        var psid = passenger_ids || [];
        psid.push(response.member_id)
        const new_Arr = remove_duplicates(psid)
        // debugger;
        dispatch(setPassengerIds(new_Arr))
        setCheckSave(1)
        showAlertMessage('success', 'Member added successfully!', true, false)
      }
    }
  };

  const handleChange = (e, index, type = 'adult') => {
    console.log(e.target.value.trim());
    if (e.target.name == 'gender' && type == 'adult') {
      let gd = e.target.value;
      if (gd == 1) {
        updateFormData({
          ...formData,
          title: 'Mr',
          [e.target.name]: e.target.value.trim()
        })

      } else if (gd == 2) {
        updateFormData({
          ...formData,
          title: 'Mrs',
          [e.target.name]: e.target.value.trim()
        })

      }
    } else {
      let gd = e.target.value;
      if (gd == 1) {
        updateFormData({
          ...formData,
          title: 'Mstr',
          [e.target.name]: e.target.value.trim()
        })

      } else if (gd == 2) {
        updateFormData({
          ...formData,
          title: 'Mstr',
          [e.target.name]: e.target.value.trim()
        })

      }

    }

    updateFormData({
      ...formData,
      [e.target.name]: e.target.value.trim(),
    })
  };
  return (
    <>
      <div class="card" style={{ width: "55rem" }}>
        <div class="card-header">
          <div class="row">
            <div class="col-lg-6">
              <p>
                Passenger  - <span>({props.PassengerType == 1 ? 'Adult' : props.PassengerType == 2 ? 'Child' : props.PassengerType == 3 ? 'Infant' : ''} {props.count_no + 1})</span>
              </p>
            </div>
            <div class="col-lg-6">

            </div>
          </div>
        </div>
        <ul class="list-group list-group-flush">
          <li class="list-group-item">
            <div class="row">
              <div class="col-lg-2">First Name:</div>

              <div className="col-lg-1">
                <select
                  name="title"
                  class="form-select"
                  onChange={(e) => handleChange(e, props.PassengerType == 1 ? 'adult' : props.PassengerType == 2 ? 'child' : props.PassengerType == 3 ? 'infant' : '')}
                  aria-label="Default select example"
                >
                  <option selected>Title</option>
                  <option value="Mr">Mr</option>
                  <option value="Ms">Ms</option>
                  <option value="Mrs">Mrs</option>
                </select>
              </div>
              <div class="col-lg-4">
                <div class="mb-3 row">
                  <div class="col-sm-10">
                    <input
                      onChange={(e) => handleChange(e, props.PassengerType == 1 ? 'adult' : props.PassengerType == 2 ? 'child' : props.PassengerType == 3 ? 'infant' : '')}
                      name="firstname"
                      type="text"
                      class="form-control"
                      id="inputPassword"
                      required
                    />
                      <ul class={searchPass.length ? "dropdown-menu inner show" : "dropdown-menu inner"} role="presentation" style={{ marginTop: 0, marginBottom: 0 }}>
                        {
                          searchPass ?
                            searchPass.map((data) => {
                              return (
                                <li key={data.id}  style={{ cursor: 'pointer' }} class="dropdown-item"><span class="text">{data.firstname||''} {data.lastname||''}</span></li>
                              );
                            })
                            : ''
                        }
                      </ul>
                  </div>
                </div>
              </div>
              <div class="col-lg-2">Last Name:</div>
              <div class="col-lg-3">
                <div class="mb-3 row">
                  <div class="col-sm-12">
                    <input
                      onChange={(e) => handleChange(e, props.PassengerType == 1 ? 'adult' : props.PassengerType == 2 ? 'child' : props.PassengerType == 3 ? 'infant' : '')}
                      name="lastname"
                      type="text"
                      class="form-control"
                      id="inputPassword"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-2">Gender:</div>

              <div className="col-lg-5">
                <select
                  name="gender"
                  class="form-select"
                  aria-label="Default select example"
                  onChange={(e) => handleChange(e, props.PassengerType == 1 ? 'adult' : props.PassengerType == 2 ? 'child' : props.PassengerType == 3 ? 'infant' : '')}
                  defaultValue={1}
                  required
                >
                  <option selected>Choose</option>
                  <option value="1">Male</option>
                  <option value="2">Female</option>
                </select>
              </div>

              <div class="col-lg-2">Mobile:</div>
              <div class="col-lg-3">
                <div class="mb-3 row">
                  <div class="col-sm-12">
                    <input
                      onChange={(e) => handleChange(e, props.PassengerType == 1 ? 'adult' : props.PassengerType == 2 ? 'child' : props.PassengerType == 3 ? 'infant' : '')}
                      name="contactNo"
                      type="number"
                      class="form-control"
                      id="inputPassword"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-2">DOB:</div>

              <div className="col-lg-5">
                <input type="date"
                  onChange={(e) => handleChange(e, props.PassengerType == 1 ? 'adult' : props.PassengerType == 2 ? 'child' : props.PassengerType == 3 ? 'infant' : '')}
                  class="form-control" name="dateofbirth" placeholder="dateofbirth" />

              </div>

              <div class="col-lg-2">Email:</div>
              <div class="col-lg-3">
                <div class="mb-3 row">
                  <div class="col-sm-12">
                    <input
                      onChange={(e) => handleChange(e, props.PassengerType == 1 ? 'adult' : props.PassengerType == 2 ? 'child' : props.PassengerType == 3 ? 'infant' : '')}
                      type="email"
                      name="email"
                      class="form-control"
                      id="inputPassword"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-2">Address:</div>

              <div className="col-lg-5">
                <div class="mb-3 row">
                  <div class="col-sm-11">
                    <input
                      onChange={(e) => handleChange(e, props.PassengerType == 1 ? 'adult' : props.PassengerType == 2 ? 'child' : props.PassengerType == 3 ? 'infant' : '')}
                      type="text"
                      name="addressLine"
                      class="form-control"
                      id="inputPassword"
                    />
                  </div>
                </div>
              </div>

              <div class="col-lg-2">Country:</div>
              <div class="col-lg-3">
                <select
                  onChange={(e) => handleChange(e, props.PassengerType == 1 ? 'adult' : props.PassengerType == 2 ? 'child' : props.PassengerType == 3 ? 'infant' : '')}
                  class="form-select"
                  name="countryCode"
                  aria-label="Default select example"
                >
                  <option value="91" selected>India</option>

                </select>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-2"></div>

              <div className="col-lg-5">
                <div class="mb-3 row">
                  <div class="col-sm-11">
                    <input
                      type="name"
                      class="form-control"
                      id="inputPassword"
                    />
                  </div>
                </div>
              </div>

              <div class="col-lg-2"></div>
              <div class="col-lg-3"></div>
            </div>
            <div class="row">
              <div class="col-lg-2">City</div>

              <div className="col-lg-5">
                <div class="mb-3 row">
                  <div class="col-sm-11">
                    <input
                      type="name"
                      class="form-control"
                      id="inputPassword"
                    />
                  </div>
                </div>
              </div>

              <div class="col-lg-2"></div>
              <div class="col-lg-3"></div>
            </div>
          </li>
        </ul>
        <div class="card-footer">
          {
            checkSave == 0 ?
            <button className="btn btn-sm btn-primary" onClick={add_passenger_data} >Save</button>
            :
            <button className="btn btn-sm btn-secondary" onClick={()=>setCheckSave(0)} >Edit</button>

          }
          {/* <div class=" form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label class="form-check-label" for="flexCheckDefault">
                            GST Detail &nbsp;&nbsp;
                            <span style={{ color: "red" }}>
                              (Note : Please fill GST Detailsonly for cooperate
                              customer)
                            </span>
                          </label>
                        </div> */}
          {/* <div class=" form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label class="form-check-label" for="flexCheckDefault">
                            Push Booking to Roamer
                          </label>
                        </div>
                        <div>SSR Details</div> */}
        </div>
      </div>

    </>
  )
}

const AddPassenger = (props) => {
  const fare_rule = useSelector(state => state.global.fare_rule)
  const fare_quote = useSelector(state => state.global.fare_quote)
  // console.log('fare_quote',fare_quote);
  var airline = [];
  const Segments = fare_quote.status ? fare_quote.Results.Segments : []
  const Results = fare_quote.status ? fare_quote.Results : []
  var duration = 0;
  const airlines = useSelector((state) => state.global.airlines);

  const [loadcircle, setLoadCircle] = useState(0);
  const dispatch = useDispatch();

  const parameter = useParams();
  const get_flight_details = (data) => {
    setLoadCircle(1)
    get_fare_rule_resultindex(data).then((res) => {
      if (res.status) {
        dispatch(setFareRule({
          ...res
        }))
      } else {
        showAlertMessage('oops', res.message, false, true)
        return
      }
      get_fare_quote_resultindex(data).then((rs) => {
        if (rs.status) {
          dispatch(setFareQuote({
            ...rs
          }))
        }
      })
      setLoadCircle(0)
    })
  }
  useEffect(() => {
    get_flight_details(parameter)
  }, [])


  return loadcircle ? <Loader /> :

    (
      <DefaultTemplate>
        <Card.Header>
          <div className="row">
            <div className="col-lg-2 col-sm-12 col-5">1. Flight Search </div>
            <div className="col-lg-2 col-sm-12 col-5">2. Flight Result</div>
            <div className="col-lg-2 col-sm-12 col-6">3. Passenger Details</div>
            <div className="col-lg-2 col-sm-12 col-6">4. Review Booking</div>
            <div className="col-lg-2 col-sm-12 col-7">
              5. Booking Confirmation
            </div>
          </div>
        </Card.Header>
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <div class="row">
                <div className="card" style={{ width: "57rem" }}>
                  <div className="card-body">
                    <div className="row">


                      {Segments.length
                        ? Segments.map((datas, seg_ind) => {
                          const have_next_asset = Segments.length > 1 ? true : false
                          const total_assets = datas.length
                          return datas.map((airport, index) => {
                            duration += airport.Duration;
                            airline.push(airport.Airline.AirlineCode)

                            return (
                              <>

                                <div className="col-lg-1">
                                  <img src={`../AirlineLogo/${airport.Airline.AirlineCode}.gif`} />
                                </div>
                                <div
                                  class="col-lg-2"
                                  style={{
                                    fontSize: "12px",
                                  }}
                                >
                                  <p>
                                    {fare_quote.status ? fare_quote.Results.Segments[0][0].Airline.AirlineName : ''}<br />
                                    {/* G8-194-x */}
                                    {fare_quote.status ? fare_quote.Results.Segments[0][0].Airline.AirlineCode : ''}-{fare_quote.status ? fare_quote.Results.Segments[0][0].Airline.FlightNumber : ''}-{fare_quote.status ? fare_quote.Results.Segments[0][0].Airline.FareClass : ''}
                                  </p>
                                </div>
                                <div class="col-lg-3" style={{ fontSize: "12px" }}>
                                  {/* <p>DEL Mon, 17 Jan 2022 | 20:50 hrs</p> */}
                                  <p>
                                    {seg_ind == 0 && index == 0 ? airport.Origin.Airport.AirportCode + ' ' + flight_dateTimeFormat(airport.Origin.DepTime) : ''}
                                  </p>
                                </div>
                                <div class="col-lg-3" style={{ fontSize: "12px" }}>
                                  {/* <p>DEL Mon, 17 Jan 2022 | 20:50 hrs</p> */}
                                  <p>
                                    {have_next_asset ? ((seg_ind == 1 && index == datas.length - 1) ? airport.Destination.Airport.AirportCode + ' ' + flight_dateTimeFormat(airport.Destination.ArrTime) : "") : (seg_ind == 0 && index == datas.length - 1 ? airport.Destination.Airport.AirportCode + ' ' + flight_dateTimeFormat(airport.Destination.ArrTime) : "")}

                                  </p>
                                </div>


                              </>
                            )
                          })
                        })
                        : ''



                      }
                      <div class="col-lg-2" style={{ fontSize: "12px" }}>
                        Duration : {secondsToHms(duration * 60)}
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              <div class="row">
                <div className="card" style={{ width: "57rem" }}>
                  <div className="card-body">
                    <div className="row">
                      <div class="col-lg-9">Enter Passenger Details</div>

                      <div class="col-lg-3">
                        <button type="button" class="btn btn-link">
                          Choose another Fare
                        </button>
                      </div>
                      <p style={{ fontSize: "12px" }}>
                        (Please add correct details of the passenger as mentioned
                        in ID Proof with mobile number so that Airline can inform
                        them in case of any change in the flight timming.)
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="card">

                  <div className="card-body">
                    <div>
                      <h4>Enter Passenger Details</h4>
                    </div>
                    {
                      fare_quote.Results.FareBreakdown.map((dt, index) => {
                        var psgrdata = []
                        for (var i = 0; i < dt.PassengerCount; i++) {
                          psgrdata.push(<PassengerData  {...dt} count_no={i} />)
                        }
                        return <>{psgrdata}</>

                      })
                    }
                  </div>

                </div>
              </div>
              <div className="row">
                <div className="card">
                  <div className="card-body">
                    <p>Baggage Details :</p>
                    <div class="card" style={{ width: "55rem" }}>
                      <div class="card-header">
                        <div class="row">
                          <div class="col-lg-3">Sector</div>
                          <div class="col-lg-3">Cabin</div>
                          <div class="col-lg-3">Check-in</div>
                          <div class="col-lg-3">Cabin Class</div>
                        </div>
                      </div>
                      {
                        Segments ?
                          Segments.map(dt => {
                            return dt.map(rss => {
                              return (
                                <div class="row" style={{ paddingLeft: "15px" }}>
                                  <div class="col-lg-3">{rss.Origin.Airport.AirportCode} - {rss.Destination.Airport.AirportCode}</div>
                                  <div class="col-lg-3">{rss.CabinBaggage}</div>
                                  <div class="col-lg-3">{rss.Baggage}</div>
                                  <div class="col-lg-3">{rss.CabinClass}</div>
                                </div>

                              )
                            })
                          })

                          : ""
                      }

                    </div>

                    {/* <div class="row" style={{ marginTop: "20px" }}>
                      <div class="col-lg-3"></div>
                      <div class="col-lg-3">DEL-GOI</div>
                    </div>

                    <div class="row">
                      <div class="col-lg-3">
                        <p>
                          Select Excess Baggage
                          <br />
                          (Extra charges will be <br />
                          applicable):
                        </p>
                      </div>
                      <div class="col-lg-3">
                        <select
                          class="form-select"
                          aria-label="Default select example"
                        >
                          <option selected>No Excess/Extra Baggage</option>
                          <option value="1">Nil</option>
                          <option value="2">Nil</option>
                        </select>
                        <p style={{ color: "blue", fontSize: "15px" }}>
                          Baggage Weight: 0 Kg
                        </p>
                        <p style={{ color: "blue", fontSize: "15px" }}>
                          Baggage Charges: Rs.0
                        </p>
                      </div>
                    </div> */}

                    {/* <div class="row" style={{ marginTop: "20px" }}>
                      <div class="col-lg-3">Meal Preferences:</div>
                      <div class="col-lg-3">DEL-GOI</div>
                    </div>

                    <div class="row">
                      <div class="col-lg-3"></div>
                      <div class="col-lg-3">
                        <select
                          class="form-select"
                          aria-label="Default select example"
                        >
                          <option selected>Add No Meal Rs- 0</option>
                          <option value="1">Nil</option>
                          <option value="2">Nil</option>
                        </select>
                        <p style={{ color: "blue", fontSize: "15px" }}>
                          Meal quantity: 0 Platter
                        </p>
                        <p style={{ color: "blue", fontSize: "15px" }}>
                          Meal Charges: Rs.0
                        </p>
                      </div>
                    </div>
                    <div class=" form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label class="form-check-label" for="flexCheckDefault">
                        Save/Update Customer in "My Customer" List.
                      </label>
                    </div> */}
                  </div>
                </div>
                {/* <div class="card" style={{ width: "58rem" }}>
                  <div class="card-header">Remark:</div>
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item">Enter Remark:</li>
                    <textarea
                      rows="3"
                      cols="30"
                      name="comment"
                      form="usrform"
                    ></textarea>
                  </ul>
                </div> */}
              </div>
            </div>
            {/* <SaleSummary /> */}
          </div>
        </div>
      </DefaultTemplate>
    )
}
export default AddPassenger